var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import Icon from '../icon/Icon';
import { NavLink } from 'react-router-dom';
// Элемент выезжающего меню
var DrawerItem = /** @class */ (function (_super) {
    __extends(DrawerItem, _super);
    function DrawerItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DrawerItem.prototype.render = function () {
        var _a = this.props, iconPath = _a.iconPath, href = _a.href, name = _a.name, isNavLink = _a.isNavLink, target = _a.target, className = _a.className, onClick = _a.onClick;
        var content = (React.createElement("div", { className: 'p-secondary drawer-link-content ' + className },
            React.createElement(Icon, { path: iconPath, color: 'black', className: 'mr-secondary' }),
            React.createElement("span", null, name)));
        if (isNavLink) {
            return (React.createElement(NavLink, { className: 'drawer-link', to: href, onClick: onClick }, content));
        }
        else {
            return (React.createElement("a", { className: 'drawer-link', href: href, target: target }, content));
        }
    };
    return DrawerItem;
}(Component));
export default DrawerItem;
//# sourceMappingURL=DrawerItem.js.map